export default function MySQL_MID() {
  return (
    <div>
      <h2>MySQL_MID</h2>    </div>
  );
}